import { createAction } from '@ngrx/store';

export const openSidebar = createAction('[ SIDEBAR ] Open');
export const closeSidebar = createAction('[ SIDEBAR ] Close');
export const toggleSidebar = createAction('[ SIDEBAR ] Toggle');
